import { useState } from 'react';
import { getDecodedJwtToken, getDecodedMfaToken } from 'lib/src/utils/jwt';
import useFetchMfaSetup from '@pages/profile/hooks/useFetchMfaSetup';
import usePostMfaVerification from '@pages/profile/hooks/usePostMfaVerification';
import MfaInner from '@components/mfa/MfaInner';
import Title from 'lib/src/components/typography/Title';
import { Redirect } from 'react-router-dom';
import useMfaRedirect from './hooks/useMfaRedirect';

const Mfa: React.FC = () => {
    const decodedToken = getDecodedJwtToken();
    const decodedMfaToken = getDecodedMfaToken();
    const hasMfa = decodedMfaToken?.hasMfa;
    const isSignedIn = !!decodedToken && !decodedToken.requiresMfa;
    const hasMfaSession = decodedMfaToken?.requiresMfa === true;

    const [stage, setStage] = useState<'setup' | 'verify'>(hasMfa ? 'verify' : 'setup');
    const { isFetching, fetchError, mfaSetupKey } = useFetchMfaSetup(
        !isSignedIn && hasMfaSession && hasMfa === false,
    );
    const { isPosting, postError, formState, handleChange, handleSubmit } = usePostMfaVerification(
        !!hasMfa,
    );

    const redirectURL = useMfaRedirect();

    if (isSignedIn) return <Redirect to={redirectURL} />;
    if (!hasMfaSession) return <Redirect to="/auth/login" />;

    return (
        <div className="login-form-wrapper">
            <div className="login-form mfa-form">
                <Title>{stage === 'verify' ? 'Verify MFA' : 'Setup MFA'}</Title>
                <MfaInner
                    stage={stage}
                    setStage={setStage}
                    isFetching={isFetching}
                    fetchError={fetchError}
                    mfaSetupKey={mfaSetupKey}
                    isPosting={isPosting}
                    postError={postError}
                    formState={formState}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    hasMfa={hasMfa}
                />
            </div>
        </div>
    );
};

export default Mfa;
